var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/banner/banner.tsx";
import classNames from 'clsx';
import React from 'react';

/** Displays a sticky full-width banner at the bottom of the screen. */
const Banner = _ref => {
  let {
    theme,
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "banner",
    className: classNames('fixed bottom-0 left-0 right-0 py-8 z-50', {
      'backdrop-blur bg-primary-800/80 dark:bg-primary-900/80': theme === 'frosted',
      'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 shadow-3xl dark:shadow-inset': theme === 'opaque'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "max-w-4xl mx-auto px-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, children));
};

export default Banner;